var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavSelect',{ref:"select",attrs:{"initialValue":"category","options":_vm.categories,"disabled":_vm.disabled},on:{"select":_vm.onCategorySelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }